import logger from '@/lib/logger';
import axios from 'axios';
import type { ClientConfiguration } from '../types/config';
import { DEFAULT_CONFIG } from '../types/config';

class ConfigService {
  private config: ClientConfiguration | null = null;
  private loading: Promise<ClientConfiguration> | null = null;

  async getConfig(): Promise<ClientConfiguration> {
    if (this.config) {
      return this.config;
    }

    if (this.loading) {
      return this.loading;
    }

    this.loading = this.fetchConfig();
    return this.loading;
  }

  private async fetchConfig(): Promise<ClientConfiguration> {
    try {
      const response = await axios.get<ClientConfiguration>(
        '/api/v1/config/client',
        { timeout: 5000 }
      );
      this.config = response.data;
      return this.config;
    } catch (error) {
      logger.warn('Failed to fetch client config, using defaults:', error);
      this.config = DEFAULT_CONFIG;
      return this.config;
    }
  }

  // Synchronous access for initialized config
  get current(): ClientConfiguration {
    return this.config ?? DEFAULT_CONFIG;
  }
}

export const configService = new ConfigService();
